import React from 'react';
import { Field } from "formik";
import { makeStyles, } from "@material-ui/core";
import Textfield from "../../components/formikcomponent/TextField";
const FieldText = (props) => {
   const useStyles = makeStyles(() => ({ inputItem: { width: "100%" } }));
   const classes = useStyles();
   return (
      <Field
         name={props.name}
         component={Textfield}
         variant="filled"
         label={props.label}
         className={classes.inputItem}
         disabled={props.disabled}
      />

   );
};
export default FieldText;